// extracted by mini-css-extract-plugin
module.exports = {"headerBar":"G-z","pointsSection":"H-z","goToDashboard":"I-z"};